import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Fade } from "react-reveal";

function About() {
  return (
    <section id="about" className="black-text">
      <Container>
        <Row className="about-row">
          <Col md={6}>
            <h2 id="about-heading-1" className="recipe-subheading">
              ABOUT
            </h2>
            <img
              src="./images/ocean-avtr.jpg"
              id="about-img"
              alt="Ocean Carlisle"
            />
          </Col>
          <Col md={6}>
            <Fade bottom duration={2000}>
              <h2 id="about-heading-2" className="recipe-subheading">
                ABOUT
              </h2>
              <p id="about-p">
                My name is Ocean (yes that is my actual name!!) and I create
                cooking videos with the help of my adorable cat, Dexter! Through
                working in the restaurant industry starting at 16 years old, I
                have developed a strong passion for cooking that has driven me
                to learn new things about food. I hope to not only entertain and
                share my crafted recipes with this community, but also inspire
                and excite you to start cooking and try something new!
              </p>
              <div className="text-center">
                <Button className="home-recipes-btn" href="/recipes">
                  Recipes
                </Button>
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
